/**
 * Featured kits — real, bookable listings on the homepage.
 *
 * Rebuilt 2026-07-02 (owner decision): replaces the occasion tile grid
 * (the hero already offers occasion entry via the dropdown + quick
 * pills, and with a small catalog the 8 tiles mostly dead-ended) AND
 * the old placeholder version of this file (hardcoded fake kits).
 *
 * Renders the SHARED ListingCard — same photos, same all-in prices,
 * same anatomy as the search page (the price-markup rule requires all
 * renter-facing price surfaces to go through it). Newest published
 * kits fill it automatically via RentEventHomePage.duck; a hand-picked
 * "featured" flag can layer on later. Desktop: 4-up grid. Mobile:
 * swipeable snap row with the next card peeking.
 */

import React from 'react';

import { ListingCard, NamedLink } from '../../../components';

import css from './FeaturedListingsSection.module.css';

const FeaturedListingsSection = ({ listings = [] }) => {
  // Nothing to feature → render nothing (a header over an empty grid
  // would advertise an empty marketplace).
  if (!listings.length) return null;

  return (
    <section className={css.root}>
      <div className={css.container}>
        <div className={css.header}>
          <div>
            <h2 className={css.title}>Featured kits</h2>
            <p className={css.description}>
              Real kits from Santa Barbara hosts, styled, photographed, and ready to book.
            </p>
          </div>
          <NamedLink name="SearchPage" className={css.seeAll}>
            See all kits &rarr;
          </NamedLink>
        </div>

        <div className={css.grid}>
          {listings.map(l => (
            <div key={l.id.uuid} className={css.gridItem}>
              <ListingCard listing={l} />
            </div>
          ))}
        </div>

        <div className={css.cta}>
          <NamedLink name="SearchPage" className={css.ctaButton}>
            Browse all party kits
          </NamedLink>
        </div>
      </div>
    </section>
  );
};

export default FeaturedListingsSection;
